






import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({})
export default class ProductBadge extends Vue {
  @Prop({ required: true, type: String })
  productName!: string;

  @Prop({ required: false, type: String })
  productId?: string;

  @Prop({ required: false, type: Boolean, default: false })
  hasDate!: boolean;

  private readonly badgeColors = [
    { bg: '#E63946', text: '#FFFFFF' }, // 1. Rot
    { bg: '#2A9D8F', text: '#FFFFFF' }, // 2. Teal
    { bg: '#F77F00', text: '#FFFFFF' }, // 3. Orange
    { bg: '#06AED5', text: '#FFFFFF' }, // 4. Cyan
    { bg: '#9B59B6', text: '#FFFFFF' }, // 5. Violett
    { bg: '#E74C3C', text: '#FFFFFF' }, // 6. Hellrot
    { bg: '#16A085', text: '#FFFFFF' }, // 7. Dunkel-Teal
    { bg: '#F39C12', text: '#FFFFFF' }, // 8. Gelb-Orange
    { bg: '#3498DB', text: '#FFFFFF' }, // 9. Blau
    { bg: '#8E44AD', text: '#FFFFFF' }, // 10. Dunkel-Violett
    { bg: '#E91E63', text: '#FFFFFF' }, // 11. Pink
    { bg: '#00B894', text: '#FFFFFF' }, // 12. Mint-Grün
    { bg: '#D35400', text: '#FFFFFF' }, // 13. Dunkel-Orange
    { bg: '#2980B9', text: '#FFFFFF' }, // 14. Dunkel-Blau
    { bg: '#C0392B', text: '#FFFFFF' }, // 15. Dunkel-Rot
    { bg: '#27AE60', text: '#FFFFFF' }, // 16. Grün
    { bg: '#A569BD', text: '#FFFFFF' }, // 17. Lila
    { bg: '#F1C40F', text: '#1F2937' }, // 18. Gelb
    { bg: '#E67E22', text: '#FFFFFF' }, // 19. Karotte
    { bg: '#1ABC9C', text: '#FFFFFF' }, // 20. Türkis
    { bg: '#5DADE2', text: '#FFFFFF' }, // 21. Himmelblau
    { bg: '#34495E', text: '#FFFFFF' }, // 22. Dunkel-Grau-Blau
    { bg: '#E84393', text: '#FFFFFF' }, // 23. Hell-Pink
    { bg: '#48C9B0', text: '#1F2937' }, // 24. Aquamarin
    { bg: '#6C5CE7', text: '#FFFFFF' }, // 25. Indigo
    { bg: '#FD79A8', text: '#1F2937' }, // 26. Rosa
    { bg: '#FDCB6E', text: '#1F2937' }, // 27. Hell-Gelb
    { bg: '#58D68D', text: '#1F2937' }, // 28. Hellgrün
    { bg: '#0984E3', text: '#FFFFFF' }, // 29. Königsblau
    { bg: '#D63031', text: '#FFFFFF' }, // 30. Karminrot
    { bg: '#A04000', text: '#FFFFFF' }, // 31. Braun
    { bg: '#17A589', text: '#FFFFFF' }, // 32. Smaragd-Grün
    { bg: '#AF7AC5', text: '#FFFFFF' }, // 33. Orchidee
    { bg: '#EC7063', text: '#FFFFFF' }, // 34. Lachs
    { bg: '#5499C7', text: '#FFFFFF' }, // 35. Stahlblau
    { bg: '#45B39D', text: '#FFFFFF' }, // 36. Jade
    { bg: '#F8B500', text: '#1F2937' }, // 37. Bernstein
    { bg: '#BB8FCE', text: '#1F2937' }, // 38. Lavendel
    { bg: '#52BE80', text: '#FFFFFF' }, // 39. Smaragd
    { bg: '#DC7633', text: '#FFFFFF' }, // 40. Terrakotta
  ];
  get badgeStyle(): { backgroundColor: string; color: string } {
    let selectedColor;

    // Wenn kein Produkt zugewiesen ist, verwende eine feste graue Farbe
    if (
      !this.productId ||
      this.productName === 'Kein Produkt' ||
      this.productName === 'Unbekannt'
    ) {
      selectedColor = { bg: '#6c757d', text: '#FFFFFF' };
    } else {
      const colorIndex = this.getColorIndexFromUUID(this.productId);
      selectedColor = this.badgeColors[colorIndex];
    }

    return {
      backgroundColor: selectedColor.bg,
      color: selectedColor.text,
    };
  }
  private getColorIndexFromUUID(uuid: string): number {
    const cleanUuid = uuid.replace(/-/g, '');
    const part1 = parseInt(cleanUuid.substring(0, 8), 16);
    const part2 = parseInt(cleanUuid.substring(8, 16), 16);
    const part3 = parseInt(cleanUuid.substring(24, 32), 16);
    const combined = part1 ^ part2 ^ part3;

    return Math.abs(combined) % this.badgeColors.length;
  }
}
